<template>
  <div id="admin-layout">
    <Header />
    <Sidebar />
    <div class="content-admin">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import Header from './HeaderAdmin'
  import Sidebar from './Sidebar';

  export default {
    name: 'PublicLayout',
    components: {
      Header,
      Sidebar
    }
  }
</script>

<style scoped>
</style>